const { Box, Img, Heading, Text, Stack } = require("@chakra-ui/react");
const {useNavigate} =require("react-router-dom");
export const Appliences = () => {
  const navigate = useNavigate();
  return (
    <Box onClick={() => {
      navigate("/product?service=Electricians");
    }} textAlign={"center"} bgColor={"white"}>
      <Heading pt={"10px"} pb={"10px"}>
        Appliances
      </Heading>
      <Text as={"small"} fontWeight={"light"}>
        Servicing, Repair, Installation & Uninstallation
      </Text>
      <Stack
        display={"flex"}
        flexDirection={"row"}
        w={"50%"}
        m={"auto"}
        p={"20px"}
        gap={"10px"}
        alignItems={"center"}
        mt={"50px"}
      >
        <Box>
          <Img
            src={
              "https://res.cloudinary.com/urbanclap/image/upload/q_auto,f_auto,fl_progressive:steep,w_532/t_high_res_category/categories/category_v2/category_c0667020.png"
            }
            width={"30vw"}
            h={"15vh"}
            borderRadius={"5px"}
          />
          <Text>Geyser</Text>
          <Text as={"small"}>Starts at ₹249</Text>
        </Box>
        <Box>
          <Img
            src={
              "https://res.cloudinary.com/urbanclap/image/upload/q_auto,f_auto,fl_progressive:steep,w_532/t_high_res_category/categories/category_v2/category_bbb8c690.png"
            }
            width={"30vw"}
            h={"15vh"}
            borderRadius={"5px"}
          />
          <Text>Water Purifier Service</Text>
          <Text>Up to 45% off</Text>
        </Box>
        <Box>
          <Img
            src={
              "https://res.cloudinary.com/urbanclap/image/upload/q_auto,f_auto,fl_progressive:steep,w_532/t_high_res_category/images/growth/home-screen/1635829954373-d05590.jpeg"
            }
            width={"30vw"}
            h={"15vh"}
            borderRadius={"5px"}
          />
          <Text>Air Purifier</Text>
          <Text as={"small"} fontWeight={"light"}>
            Flat ₹100 off
          </Text>
        </Box>
      </Stack>
    </Box>
  );
};
